// @generated by protobuf-ts 2.11.1 with parameter long_type_number,generate_dependencies
// @generated from protobuf file "shared/external-apis/vlp-notification/vlp-notification-admin-external-apis.proto" (package "vlp.notification", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ExternalNotificationAdminRPC } from "./vlp-notification-admin-external-apis";
import type { TestSendNotificationResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { TestSendNotificationRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { AlertSilenceResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { AlertSilenceDTO } from "../../../domains/vlp-notification/vlp-notification-delivery-model";
import type { AlertSilenceListResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { ResolveIncidentRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { AlertIncidentResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { AcknowledgeIncidentRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { AlertIncidentListResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { ListAlertIncidentsRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationDeliveryListResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { ListDeliveryHistoryRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationPreferenceResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationPreferenceDTO } from "../../../domains/vlp-notification/vlp-notification-definition-model";
import type { NotificationPreferenceListResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { UnregisterMyPushDeviceRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationDeviceResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { RegisterMyPushDeviceRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { DeleteMyReadNotificationsResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { DeleteMyReadNotificationsRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { MarkNotificationReadResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { MarkNotificationReadRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { MyNotificationsResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { ListMyNotificationsRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { TestNotificationMailProfileResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { TestNotificationMailProfileRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { SaveNotificationMailCredentialRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationMailProfileResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationMailProfileDTO } from "../../../domains/vlp-notification/vlp-notification-definition-model";
import type { NotificationMailProfileListResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { ListNotificationMailProfilesRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationTemplateResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationTemplateDTO } from "../../../domains/vlp-notification/vlp-notification-definition-model";
import type { NotificationTemplateListResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { ListNotificationTemplatesRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationIdRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationRecipientRuleResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationRecipientRuleDTO } from "../../../domains/vlp-notification/vlp-notification-definition-model";
import type { NotificationRuleResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationRuleDTO } from "../../../domains/vlp-notification/vlp-notification-definition-model";
import type { NotificationRuleListResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { ListNotificationRulesRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationDefinitionResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { NotificationDefinitionDTO } from "../../../domains/vlp-notification/vlp-notification-definition-model";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { NotificationDefinitionListResponse } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { ListNotificationDefinitionsRequest } from "../../../domains/vlp-notification/vlp-notification-admin-request-response";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service vlp.notification.ExternalNotificationAdminRPC
 */
export interface IExternalNotificationAdminRPCClient {
    /**
     * Catalog definition (LUL-653 #1)
     *
     * @generated from protobuf rpc: ListNotificationDefinitions
     */
    listNotificationDefinitions(input: ListNotificationDefinitionsRequest, options?: RpcOptions): UnaryCall<ListNotificationDefinitionsRequest, NotificationDefinitionListResponse>;
    /**
     * @generated from protobuf rpc: AddOrUpdateNotificationDefinition
     */
    addOrUpdateNotificationDefinition(input: NotificationDefinitionDTO, options?: RpcOptions): UnaryCall<NotificationDefinitionDTO, NotificationDefinitionResponse>;
    /**
     * Rule + recipient routing (#4)
     *
     * @generated from protobuf rpc: ListNotificationRules
     */
    listNotificationRules(input: ListNotificationRulesRequest, options?: RpcOptions): UnaryCall<ListNotificationRulesRequest, NotificationRuleListResponse>;
    /**
     * @generated from protobuf rpc: AddOrUpdateNotificationRule
     */
    addOrUpdateNotificationRule(input: NotificationRuleDTO, options?: RpcOptions): UnaryCall<NotificationRuleDTO, NotificationRuleResponse>;
    /**
     * @generated from protobuf rpc: AddOrUpdateRecipientRule
     */
    addOrUpdateRecipientRule(input: NotificationRecipientRuleDTO, options?: RpcOptions): UnaryCall<NotificationRecipientRuleDTO, NotificationRecipientRuleResponse>;
    /**
     * @generated from protobuf rpc: RemoveRecipientRule
     */
    removeRecipientRule(input: NotificationIdRequest, options?: RpcOptions): UnaryCall<NotificationIdRequest, NotificationRecipientRuleResponse>;
    /**
     * Template/version/language (#5)
     *
     * @generated from protobuf rpc: ListNotificationTemplates
     */
    listNotificationTemplates(input: ListNotificationTemplatesRequest, options?: RpcOptions): UnaryCall<ListNotificationTemplatesRequest, NotificationTemplateListResponse>;
    /**
     * @generated from protobuf rpc: AddOrUpdateNotificationTemplate
     */
    addOrUpdateNotificationTemplate(input: NotificationTemplateDTO, options?: RpcOptions): UnaryCall<NotificationTemplateDTO, NotificationTemplateResponse>;
    /**
     * Outbound SMTP profile scoped to tenant / organization unit.
     *
     * @generated from protobuf rpc: ListNotificationMailProfiles
     */
    listNotificationMailProfiles(input: ListNotificationMailProfilesRequest, options?: RpcOptions): UnaryCall<ListNotificationMailProfilesRequest, NotificationMailProfileListResponse>;
    /**
     * @generated from protobuf rpc: AddOrUpdateNotificationMailProfile
     */
    addOrUpdateNotificationMailProfile(input: NotificationMailProfileDTO, options?: RpcOptions): UnaryCall<NotificationMailProfileDTO, NotificationMailProfileResponse>;
    /**
     * @generated from protobuf rpc: SaveNotificationMailCredential
     */
    saveNotificationMailCredential(input: SaveNotificationMailCredentialRequest, options?: RpcOptions): UnaryCall<SaveNotificationMailCredentialRequest, NotificationMailProfileResponse>;
    /**
     * @generated from protobuf rpc: TestNotificationMailProfile
     */
    testNotificationMailProfile(input: TestNotificationMailProfileRequest, options?: RpcOptions): UnaryCall<TestNotificationMailProfileRequest, TestNotificationMailProfileResponse>;
    /**
     * Inbox người dùng (#10 FE persistent inbox)
     *
     * @generated from protobuf rpc: ListMyNotifications
     */
    listMyNotifications(input: ListMyNotificationsRequest, options?: RpcOptions): UnaryCall<ListMyNotificationsRequest, MyNotificationsResponse>;
    /**
     * @generated from protobuf rpc: MarkNotificationRead
     */
    markNotificationRead(input: MarkNotificationReadRequest, options?: RpcOptions): UnaryCall<MarkNotificationReadRequest, MarkNotificationReadResponse>;
    /**
     * @generated from protobuf rpc: DeleteMyReadNotifications
     */
    deleteMyReadNotifications(input: DeleteMyReadNotificationsRequest, options?: RpcOptions): UnaryCall<DeleteMyReadNotificationsRequest, DeleteMyReadNotificationsResponse>;
    /**
     * Thiết bị nhận push của người dùng hiện tại (mobile)
     *
     * @generated from protobuf rpc: RegisterMyPushDevice
     */
    registerMyPushDevice(input: RegisterMyPushDeviceRequest, options?: RpcOptions): UnaryCall<RegisterMyPushDeviceRequest, NotificationDeviceResponse>;
    /**
     * @generated from protobuf rpc: UnregisterMyPushDevice
     */
    unregisterMyPushDevice(input: UnregisterMyPushDeviceRequest, options?: RpcOptions): UnaryCall<UnregisterMyPushDeviceRequest, NotificationDeviceResponse>;
    /**
     * Preference cá nhân (không tắt được Mandatory)
     *
     * @generated from protobuf rpc: GetMyNotificationPreferences
     */
    getMyNotificationPreferences(input: ListNotificationDefinitionsRequest, options?: RpcOptions): UnaryCall<ListNotificationDefinitionsRequest, NotificationPreferenceListResponse>;
    /**
     * @generated from protobuf rpc: AddOrUpdateMyNotificationPreference
     */
    addOrUpdateMyNotificationPreference(input: NotificationPreferenceDTO, options?: RpcOptions): UnaryCall<NotificationPreferenceDTO, NotificationPreferenceResponse>;
    /**
     * Delivery history + incident (#6/#9)
     *
     * @generated from protobuf rpc: ListDeliveryHistory
     */
    listDeliveryHistory(input: ListDeliveryHistoryRequest, options?: RpcOptions): UnaryCall<ListDeliveryHistoryRequest, NotificationDeliveryListResponse>;
    /**
     * @generated from protobuf rpc: ListAlertIncidents
     */
    listAlertIncidents(input: ListAlertIncidentsRequest, options?: RpcOptions): UnaryCall<ListAlertIncidentsRequest, AlertIncidentListResponse>;
    /**
     * @generated from protobuf rpc: AcknowledgeIncident
     */
    acknowledgeIncident(input: AcknowledgeIncidentRequest, options?: RpcOptions): UnaryCall<AcknowledgeIncidentRequest, AlertIncidentResponse>;
    /**
     * @generated from protobuf rpc: ResolveIncident
     */
    resolveIncident(input: ResolveIncidentRequest, options?: RpcOptions): UnaryCall<ResolveIncidentRequest, AlertIncidentResponse>;
    /**
     * Silence / maintenance window (#6)
     *
     * @generated from protobuf rpc: ListAlertSilences
     */
    listAlertSilences(input: NotificationIdRequest, options?: RpcOptions): UnaryCall<NotificationIdRequest, AlertSilenceListResponse>;
    /**
     * @generated from protobuf rpc: AddOrUpdateAlertSilence
     */
    addOrUpdateAlertSilence(input: AlertSilenceDTO, options?: RpcOptions): UnaryCall<AlertSilenceDTO, AlertSilenceResponse>;
    /**
     * Test-send tới chính người gọi (AC 10)
     *
     * @generated from protobuf rpc: TestSendNotification
     */
    testSendNotification(input: TestSendNotificationRequest, options?: RpcOptions): UnaryCall<TestSendNotificationRequest, TestSendNotificationResponse>;
}
/**
 * @generated from protobuf service vlp.notification.ExternalNotificationAdminRPC
 */
export class ExternalNotificationAdminRPCClient implements IExternalNotificationAdminRPCClient, ServiceInfo {
    typeName = ExternalNotificationAdminRPC.typeName;
    methods = ExternalNotificationAdminRPC.methods;
    options = ExternalNotificationAdminRPC.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Catalog definition (LUL-653 #1)
     *
     * @generated from protobuf rpc: ListNotificationDefinitions
     */
    listNotificationDefinitions(input: ListNotificationDefinitionsRequest, options?: RpcOptions): UnaryCall<ListNotificationDefinitionsRequest, NotificationDefinitionListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListNotificationDefinitionsRequest, NotificationDefinitionListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddOrUpdateNotificationDefinition
     */
    addOrUpdateNotificationDefinition(input: NotificationDefinitionDTO, options?: RpcOptions): UnaryCall<NotificationDefinitionDTO, NotificationDefinitionResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<NotificationDefinitionDTO, NotificationDefinitionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Rule + recipient routing (#4)
     *
     * @generated from protobuf rpc: ListNotificationRules
     */
    listNotificationRules(input: ListNotificationRulesRequest, options?: RpcOptions): UnaryCall<ListNotificationRulesRequest, NotificationRuleListResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListNotificationRulesRequest, NotificationRuleListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddOrUpdateNotificationRule
     */
    addOrUpdateNotificationRule(input: NotificationRuleDTO, options?: RpcOptions): UnaryCall<NotificationRuleDTO, NotificationRuleResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<NotificationRuleDTO, NotificationRuleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddOrUpdateRecipientRule
     */
    addOrUpdateRecipientRule(input: NotificationRecipientRuleDTO, options?: RpcOptions): UnaryCall<NotificationRecipientRuleDTO, NotificationRecipientRuleResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<NotificationRecipientRuleDTO, NotificationRecipientRuleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveRecipientRule
     */
    removeRecipientRule(input: NotificationIdRequest, options?: RpcOptions): UnaryCall<NotificationIdRequest, NotificationRecipientRuleResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<NotificationIdRequest, NotificationRecipientRuleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Template/version/language (#5)
     *
     * @generated from protobuf rpc: ListNotificationTemplates
     */
    listNotificationTemplates(input: ListNotificationTemplatesRequest, options?: RpcOptions): UnaryCall<ListNotificationTemplatesRequest, NotificationTemplateListResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListNotificationTemplatesRequest, NotificationTemplateListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddOrUpdateNotificationTemplate
     */
    addOrUpdateNotificationTemplate(input: NotificationTemplateDTO, options?: RpcOptions): UnaryCall<NotificationTemplateDTO, NotificationTemplateResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<NotificationTemplateDTO, NotificationTemplateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Outbound SMTP profile scoped to tenant / organization unit.
     *
     * @generated from protobuf rpc: ListNotificationMailProfiles
     */
    listNotificationMailProfiles(input: ListNotificationMailProfilesRequest, options?: RpcOptions): UnaryCall<ListNotificationMailProfilesRequest, NotificationMailProfileListResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListNotificationMailProfilesRequest, NotificationMailProfileListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddOrUpdateNotificationMailProfile
     */
    addOrUpdateNotificationMailProfile(input: NotificationMailProfileDTO, options?: RpcOptions): UnaryCall<NotificationMailProfileDTO, NotificationMailProfileResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<NotificationMailProfileDTO, NotificationMailProfileResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SaveNotificationMailCredential
     */
    saveNotificationMailCredential(input: SaveNotificationMailCredentialRequest, options?: RpcOptions): UnaryCall<SaveNotificationMailCredentialRequest, NotificationMailProfileResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<SaveNotificationMailCredentialRequest, NotificationMailProfileResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: TestNotificationMailProfile
     */
    testNotificationMailProfile(input: TestNotificationMailProfileRequest, options?: RpcOptions): UnaryCall<TestNotificationMailProfileRequest, TestNotificationMailProfileResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<TestNotificationMailProfileRequest, TestNotificationMailProfileResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Inbox người dùng (#10 FE persistent inbox)
     *
     * @generated from protobuf rpc: ListMyNotifications
     */
    listMyNotifications(input: ListMyNotificationsRequest, options?: RpcOptions): UnaryCall<ListMyNotificationsRequest, MyNotificationsResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListMyNotificationsRequest, MyNotificationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: MarkNotificationRead
     */
    markNotificationRead(input: MarkNotificationReadRequest, options?: RpcOptions): UnaryCall<MarkNotificationReadRequest, MarkNotificationReadResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<MarkNotificationReadRequest, MarkNotificationReadResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteMyReadNotifications
     */
    deleteMyReadNotifications(input: DeleteMyReadNotificationsRequest, options?: RpcOptions): UnaryCall<DeleteMyReadNotificationsRequest, DeleteMyReadNotificationsResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteMyReadNotificationsRequest, DeleteMyReadNotificationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Thiết bị nhận push của người dùng hiện tại (mobile)
     *
     * @generated from protobuf rpc: RegisterMyPushDevice
     */
    registerMyPushDevice(input: RegisterMyPushDeviceRequest, options?: RpcOptions): UnaryCall<RegisterMyPushDeviceRequest, NotificationDeviceResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<RegisterMyPushDeviceRequest, NotificationDeviceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UnregisterMyPushDevice
     */
    unregisterMyPushDevice(input: UnregisterMyPushDeviceRequest, options?: RpcOptions): UnaryCall<UnregisterMyPushDeviceRequest, NotificationDeviceResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<UnregisterMyPushDeviceRequest, NotificationDeviceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Preference cá nhân (không tắt được Mandatory)
     *
     * @generated from protobuf rpc: GetMyNotificationPreferences
     */
    getMyNotificationPreferences(input: ListNotificationDefinitionsRequest, options?: RpcOptions): UnaryCall<ListNotificationDefinitionsRequest, NotificationPreferenceListResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListNotificationDefinitionsRequest, NotificationPreferenceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddOrUpdateMyNotificationPreference
     */
    addOrUpdateMyNotificationPreference(input: NotificationPreferenceDTO, options?: RpcOptions): UnaryCall<NotificationPreferenceDTO, NotificationPreferenceResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<NotificationPreferenceDTO, NotificationPreferenceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delivery history + incident (#6/#9)
     *
     * @generated from protobuf rpc: ListDeliveryHistory
     */
    listDeliveryHistory(input: ListDeliveryHistoryRequest, options?: RpcOptions): UnaryCall<ListDeliveryHistoryRequest, NotificationDeliveryListResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListDeliveryHistoryRequest, NotificationDeliveryListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAlertIncidents
     */
    listAlertIncidents(input: ListAlertIncidentsRequest, options?: RpcOptions): UnaryCall<ListAlertIncidentsRequest, AlertIncidentListResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAlertIncidentsRequest, AlertIncidentListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AcknowledgeIncident
     */
    acknowledgeIncident(input: AcknowledgeIncidentRequest, options?: RpcOptions): UnaryCall<AcknowledgeIncidentRequest, AlertIncidentResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<AcknowledgeIncidentRequest, AlertIncidentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ResolveIncident
     */
    resolveIncident(input: ResolveIncidentRequest, options?: RpcOptions): UnaryCall<ResolveIncidentRequest, AlertIncidentResponse> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<ResolveIncidentRequest, AlertIncidentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Silence / maintenance window (#6)
     *
     * @generated from protobuf rpc: ListAlertSilences
     */
    listAlertSilences(input: NotificationIdRequest, options?: RpcOptions): UnaryCall<NotificationIdRequest, AlertSilenceListResponse> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<NotificationIdRequest, AlertSilenceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddOrUpdateAlertSilence
     */
    addOrUpdateAlertSilence(input: AlertSilenceDTO, options?: RpcOptions): UnaryCall<AlertSilenceDTO, AlertSilenceResponse> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<AlertSilenceDTO, AlertSilenceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Test-send tới chính người gọi (AC 10)
     *
     * @generated from protobuf rpc: TestSendNotification
     */
    testSendNotification(input: TestSendNotificationRequest, options?: RpcOptions): UnaryCall<TestSendNotificationRequest, TestSendNotificationResponse> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<TestSendNotificationRequest, TestSendNotificationResponse>("unary", this._transport, method, opt, input);
    }
}
